import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import { CONSTANTS } from '@/config/constants';
import { env } from '@/config/env';
import { injectUserManager } from '@nablax/shared/lib';
import { getItem, LOCAL_STORAGE_KEYS, removeItem } from '@nablax/shared/utils';

const EXCLUDE_ON_SIGNIN_REDIRECT_PATHS = ['/logout'];

export const userManager = new UserManager({
  authority: env.VITE_AUTH_SERVER_URL,
  client_id: env.VITE_AUTH_SERVER_CLIENT_ID,
  redirect_uri: `${window.location.origin}${window.location.pathname.endsWith('/') ? `${window.location.pathname}callback` : `${window.location.pathname}/callback`}`,
  post_logout_redirect_uri: `${window.location.origin}/${env.VITE_BUILD_BASE_PATH}`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  monitorSession: true,
  checkSessionIntervalInSeconds: 5,
});

/**
 * This event is triggered when the sid has been changed
 * so either the user has logged out somewhere or it has
 * logged in and this application is still holding a old session
 * that should be renewed.
//  */
userManager.events.addUserSessionChanged(() => {
  // we remove the old session
  userManager.removeUser();
  // we try to renew it manually
  userManager.signinRedirect();
});

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
  const prevPathName = getItem(
    LOCAL_STORAGE_KEYS.before_redirect_url,
    CONSTANTS.auth.defaultLandingPath,
    'sessionStorage',
  );

  if (!EXCLUDE_ON_SIGNIN_REDIRECT_PATHS.some((p) => p.includes(prevPathName))) {
    window.location.replace(prevPathName);
  } else {
    window.location.replace(CONSTANTS.auth.defaultLandingPath);
  }
  removeItem(LOCAL_STORAGE_KEYS.before_redirect_url);
};

injectUserManager(userManager);
